module.exports = __webpack_public_path__ + "static/media/test1 (19).ad61403a.jpg";